import { DateTime } from 'luxon';

export function getReadableDateTime(dateTime: string) {
    const date = DateTime.fromISO(dateTime);
    return `${date.toLocaleString(DateTime.DATE_MED)} um ${date.toLocaleString(
        DateTime.TIME_24_SIMPLE
    )} Uhr`;
}
